import React from 'react';
import { useGeneralHooks } from '../../Hooks/hooks';
import SignUpPC from './Screens/pcScreen';
import SignUpMobile from './Screens/mobileScreen';

const SignUp: React.FC = () => {
  const { largeScreen } = useGeneralHooks();

  return (
    <>
      {
        largeScreen
          ?
          <SignUpPC/>
          :
          <SignUpMobile/>
      }
    </>

  )
}

export default SignUp
